
/// <reference path="../stocknote/StockNoteCell.ts" />


class SupplierNoteCell extends StockNoteCell
{
    private referenceLabel:MUILabel = null;
    private parentDocumentNumberLabel:MUILabel = null;

    awakeFromHTML(): void {
        super.awakeFromHTML();
        
        this.referenceLabel = MUIOutlet (this, "ref-lbl", "MUILabel");
        this.parentDocumentNumberLabel = MUIOutlet (this, "parent-doc-number-lbl", "MUILabel");
    }

    set item (item:StockNote){
        this.setItem(item);
        this.setTitle(item.originName);

        this.referenceLabel.text = item.externalReference;
        this.parentDocumentNumberLabel.text = item.parentDocumentID;
        this.documentIDLabel.text = item.documentID;
    }
}